import { createMigration } from './utils';

/**
 * Renames 'readingDirection' to 'textDirection' in text asset styles.
 */
function renameReadingDirectionInStyle(map: any, stylePath: Array<string | number>) {
    const style = map.getIn(stylePath);
    if (!style) {
        return;
    }

    const readingDirection = style.get('readingDirection');
    if (readingDirection !== undefined) {
        map.setIn([...stylePath, 'textDirection'], readingDirection);
        map.deleteIn([...stylePath, 'readingDirection']);
    }
}

const TEXT_ASSET_CLASS_TYPES = ['CanvasTextAsset', 'CanvasCaptionAsset', 'CanvasFancyCaptionAsset'];

function migrateAsset(map: any, assetPath: Array<string | number>) {
    const asset = map.getIn(assetPath);
    if (!asset) {
        return;
    }

    const classType = asset.get('classType');
    if (!TEXT_ASSET_CLASS_TYPES.includes(classType)) {
        return;
    }

    renameReadingDirectionInStyle(map, [...assetPath, 'normalStyle']);
    renameReadingDirectionInStyle(map, [...assetPath, 'highlightStyle']);
    renameReadingDirectionInStyle(map, [...assetPath, 'spokenWordStyle']);
}

function migrateChildren(map: any, childrenPath: Array<string | number>) {
    const children = map.getIn(childrenPath);
    if (!children) {
        return;
    }

    children.forEach((_child: any, index: number) => {
        migrateAsset(map, [...childrenPath, index]);
    });
}

export const migrationTo9_234 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('sceneGroups').forEach((_sceneGroup: any, i: number) => {
                map.setIn(
                    ['sceneGroups', i],
                    this.migrateSceneGroup(map.getIn(['sceneGroups', i])),
                );
            });
            map.get('slides').forEach((_scene: any, i: number) => {
                map.setIn(['slides', i], this.migrateScene(map.getIn(['slides', i])));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations((map) => {
            // Migrate caption asset's styles
            migrateAsset(map, ['captions', 'asset']);
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            // Migrate children in scene
            migrateChildren(map, ['children']);

            // Migrate children in subslides
            const subslides = map.get('subslides');
            if (subslides) {
                subslides.forEach((_subslide: any, sIndex: number) => {
                    migrateChildren(map, ['subslides', sIndex, 'children']);
                });
            }
        });
    },
});
